import { useCallback, useEffect, useState } from "react";
import { createEmptyIncidentContext, getIncidentContext } from "../services/incident_context_service";

export default function useIncidentContext(incidentId) {
	const [context, setContext] = useState(createEmptyIncidentContext());
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");

	const refresh = useCallback(async () => {
		if (!incidentId) {
			setContext(createEmptyIncidentContext());
			setError("");
			return;
		}

		setLoading(true);
		setError("");

		try {
			const nextContext = await getIncidentContext(incidentId);
			setContext(nextContext);
		} catch (nextError) {
			setError(nextError?.message || "Failed to load incident context");
			setContext(createEmptyIncidentContext());
		} finally {
			setLoading(false);
		}
	}, [incidentId]);

	useEffect(() => {
		let isCancelled = false;

		async function loadContext() {
			if (!incidentId) {
				setContext(createEmptyIncidentContext());
				setError("");
				return;
			}

			setLoading(true);
			setError("");

			try {
				const nextContext = await getIncidentContext(incidentId);
				if (isCancelled) {
					return;
				}
				setContext(nextContext);
			} catch (nextError) {
				if (isCancelled) {
					return;
				}
				setError(nextError?.message || "Failed to load incident context");
				setContext(createEmptyIncidentContext());
			} finally {
				if (!isCancelled) {
					setLoading(false);
				}
			}
		}

		loadContext();

		return () => {
			isCancelled = true;
		};
	}, [incidentId]);

	return {
		context,
		loading,
		error,
		refresh,
	};
}
